/* eslint-disable max-len */
/* eslint-disable no-console */
import { Avatar, Box, Grid, Tooltip, Typography } from '@mui/material';
import React, { useCallback, useEffect, useId, useState } from 'react';
import ProfilePic from '../../../../../../components/Common/ProfilePic';

const ConnectionAvatar = (props: any) =>
{
	const { index, item, handleSelect, connectionData } = props;
	const [ imageError, setImageError ] = useState(false);
	const [ fallbackImage, setFallbackImage ] = useState<string | null>(null);

	// Default company icons array (A to Z)
	const defaultCompanyIcons = Array.from({ length: 26 }, (_, i) => ({
		key : String.fromCharCode(65 + i),
		src : `/images/icons/companyDefaultIcons/${String.fromCharCode(65 + i)}.png`
	}));
	const randomId = useId();

	// Memoized function to determine the fallback image for the first letter
	const getFallbackImage = useCallback((letter: string) =>
	{
		return new Promise<string>((resolve) =>
		{
			const defaultIcon = defaultCompanyIcons.find((icon) => icon?.key === letter);

			if (defaultIcon)
			{
				const img = new Image();

				img.onload = () => resolve(defaultIcon?.src);
				img.onerror = () => resolve(letter);
				img.src = defaultIcon?.src; // Trigger image load
			}
			else
			{
				// Resolve with the letter if no default icon exists
				resolve(letter);
			}
		});
	}, [ defaultCompanyIcons ]);

	// Effect to handle fallback image logic when the main image fails
	useEffect(() =>
	{
		let isMounted = true;

		const loadFallbackImage = async () =>
		{
			// if (!imageError) return;

			const firstLetter = item?.name?.charAt(0).toUpperCase();

			try
			{
				// Fetch the fallback image or letter
				const result = await getFallbackImage(firstLetter);

				if (isMounted)
				{
					setFallbackImage(result);
				}
			}
			catch (error)
			{
				// Default to the letter in case of an error
				console.error('Error loading fallback image:', error);
				if (isMounted)
				{
					setFallbackImage(firstLetter);
				}
			}
		};

		loadFallbackImage();

		return () =>
		{
			// Clean up: mark the component as unmounted
			isMounted = false;
		};
	}, [ ]);

	// Avatar props: dynamically set based on whether the image failed to load
	const avatarProps = imageError
		? {} // If the image fails, do not provide the `src` attribute
		: {
			src     : `${process.env.REACT_APP_S3_BASE_URL}/profile/${item?.companyId}_logo.jpeg?t=${new Date().valueOf()}`, // Main image URL
			onError : () => setImageError(true) // Set error state if the image fails to load
		};

	// Function to render avatar content (either fallback image or first letter)
	const renderAvatarContent = () =>
	{
		// if (imageError)
		// {
		if (fallbackImage?.includes('.png'))
		{
			// If fallback is an image, render it
			return (fallbackImage
			// <img
			// src={fallbackImage}
			// 	alt={item?.name}
			// 	style={{ width: 'var(--percent100)', height: 'var(--percent100)', objectFit: 'cover' }}
			// />
			);
		}

		// Otherwise, render the first letter
		return item?.name?.charAt(0).toUpperCase();
		// }//

		// Return null if no fallback is needed (main image loaded successfully)
	};

	return (
		<Grid
			item
			key={index}
			px='var(--pixel10)'
			pb='var(--pixel8)'
			onClick={() => handleSelect(item?.companyId)}
			sx={{
				display       : 'flex',
				flexDirection : 'column',
				alignItems    : 'center',
				width         : 100,
				cursor        : 'pointer'
			}}
		>
			<Box
				// {...avatarProps}//
				sx={{
					width           : 56,
					height          : 56,
					mb              : 1,
					border          : connectionData?.userId === item?.companyId ? '3px solid var(--primaryColor)' : '2px solid var(--whiteColor)',
					borderRadius    : 'var(--percent50)',
					transition      : 'transform 0.3s ease-in-out',
					'&:hover'       : { transform: 'scale(1.2)' },
					boxShadow       : '0 2px 4px 0 rgba(0, 0, 0, 0.2), 0 3px 10px 0 rgba(0, 0, 0, 0.19)',
					backgroundColor : imageError ? 'var(--grayF5)' : 'transparent',
					color           : imageError ? 'var(--black)' : 'transparent',
					fontSize        : 'var(--pixel24)',
					display         : 'flex',
					alignItems      : 'center',
					justifyContent  : 'center',
					fontWeight      : 'bold'
				}}
			>
				<ProfilePic imagePath={`${item?.companyId}_logo.jpeg?t=${randomId}`}
					defaultImg={renderAvatarContent()}
					alt='like' className='brdrRadius50'

				/>
				{/* {renderAvatarContent()} */}
			</Box>
			<Tooltip title={item?.name} placement='top'>
				<Typography
					variant='caption'
					sx={{
						textOverflow  : 'ellipsis',
						overflow      : 'hidden',
						whiteSpace    : 'nowrap',
						width         : 'var(--percent100)',
						maxWidth      : 'var(--percent100)',
						textTransform : 'capitalize'
					}}
					align='center'
				>
					{item?.name}
				</Typography>
			</Tooltip>
		</Grid>
	);
};

export default ConnectionAvatar;